import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReactToPrint from "react-to-print";

const componentRef = React.createRef();
var QRCode = require("qrcode.react");

class Aval extends React.Component {
  render() {
    return (
      <Modal
        isOpen={this.props.modalCasoEspecial}
        modalClassName="modal-message"
      >
        <ModalHeader>
          <div>
            Folio del caso especial: {this.props.caso_especial.folio}
            <button
              type="button"
              className="close"
              onClick={this.props.change}
              style={{ position: "fixed", right: "21%" }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className={this.props.working ? "" : "hide"}>
            <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
              CARGANDO INFORMACIÓN
            </div>
          </div>

          <div className={this.props.working ? "hide" : ""}>
            <div
              className="row"
              ref={componentRef}
              style={{ background: "white" }}
            >
              <form
                style={{
                  marginRight: "13%",
                  marginLeft: "13%",
                  color: "black",
                  width: "100%",
                }}
              >
                <div style={{ textAlign: "left", margin: "3%" }}>
                  <table style={{ width: "100%", tableLayout: "auto" }}>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "left", color: "black" }}>
                          <img
                            src="../assets/Escudo.jpg"
                            width="100"
                            height="100"
                            alt="escudo"
                          />
                        </td>
                        <td style={{ textAlign: "right", color: "black" }}>
                          <img
                            src="../assets/1631027847767_Logo IPSA.png"
                            width="200"
                            height="100"
                            alt="logo ipsa"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="75%">
                          <h5 style={{ textAlign: "right", margin: "5%" }}>
                            AVAL PARA SOLICITUD DE IMPORTACIÓN
                          </h5>
                        </td>
                        <td width="25%">
                          <div style={{ textAlign: "right", marginTop: "5%" }}>
                            <QRCode
                              size="100"
                              value={
                                "id: " +
                                this.props.caso_especial.id +
                                "\n" +
                                "folio: " +
                                this.props.caso_especial.folio
                              }
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* <div style={{ textAlign: "right", marginTop: "5%" }}>
                  <QRCode
                    value={
                      "id: " +
                      this.props.caso_especial.id +
                      "\n" +
                      "folio: " +
                      this.props.caso_especial.folio
                    }
                  />
                </div>
                <h5 style={{ textAlign: "center", margin: "5%" }}>
                  AVAL PARA SOLICITUD DE IMPORTACIÓN
                </h5> */}

                <div>
                  <p>
                    <b>Tipo: </b>
                    {this.props.caso_especial.tipo_producto_importacion}
                  </p>

                  <p>
                    <b>Estimado (a): </b>
                    {this.props.caso_especial.estimado}
                  </p>

                  <p>
                    <b>Por favor autorice importación de: </b>
                    {this.props.caso_especial.importacion_texto}
                  </p>

                  <p>
                    <b>Con fines de: </b>
                    {this.props.caso_especial.fines_texto}
                  </p>

                  <div style={{ textAlign: "justify", fontWeight: "bold" }}>
                    <p>
                      De los siguientes medicamentos veterinarios y productos
                      afines, o productos utilizados en alimentación animal:
                    </p>

                    <table
                      className="table table-list"
                      style={{
                        color: "#000",
                        borderCollapse: "collapse",
                        width: "100%",
                      }}
                    >
                      <thead>
                        <tr style={{ border: "1px solid #000" }}>
                          <td
                            style={{ border: "1px solid #000" }}
                            className="text-center p-0"
                          >
                            {this.props.caso_especial.tipo_importacion_id ===
                            "7"
                              ? "MATERIA PRIMA"
                              : "NOMBRE COMERCIAL"}
                          </td>
                          <td
                            style={{ border: "1px solid #000" }}
                            className="text-center p-0"
                          >
                            PRESENTACIÓN
                          </td>

                          {this.props.caso_especial
                            .tipo_producto_importacion ===
                            "MEDICAMENTOS VETERINARIOS Y PRODUCTOS A FIN" &&
                          this.props.caso_especial.tipo_importacion_id ===
                            "7" ? (
                            <td
                              style={{ border: "1px solid #000" }}
                              className="text-center p-0"
                            >
                              FABRICANTE
                            </td>
                          ) : null}

                          {!["1", "8"].includes(
                            this.props.caso_especial.tipo_importacion_id
                          ) ? (
                            <td
                              style={{ border: "1px solid #000" }}
                              className="text-center p-0"
                            >
                              PAÍS ORIGEN
                            </td>
                          ) : null}

                          <td
                            style={{ border: "1px solid #000" }}
                            className="text-center p-0"
                          >
                            CANTIDAD
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.caso_especial.listado.map((item, index) => (
                          <tr key={index} style={{ border: "1px solid #000" }}>
                            <td
                              style={{
                                border: "1px solid #000",
                                fontWeight: "normal",
                              }}
                              className="text-center p-0"
                            >
                              {this.props.caso_especial.tipo_importacion_id !==
                              "7"
                                ? item.nombre_comercial
                                : item.nombre_materia_prima}
                            </td>
                            <td
                              style={{
                                border: "1px solid #000",
                                fontWeight: "normal",
                              }}
                              className="text-center p-0"
                            >
                              {item.presentacion}
                            </td>
                            {this.props.caso_especial
                              .tipo_producto_importacion ===
                              "MEDICAMENTOS VETERINARIOS Y PRODUCTOS A FIN" &&
                            this.props.caso_especial.tipo_importacion_id ===
                              "7" ? (
                              <td
                                style={{
                                  border: "1px solid #000",
                                  fontWeight: "normal",
                                }}
                                className="text-center p-0"
                              >
                                {item.fabricante_razon_social}
                              </td>
                            ) : null}

                            {!["1", "8"].includes(
                              this.props.caso_especial.tipo_importacion_id
                            ) ? (
                              <td
                                style={{
                                  border: "1px solid #000",
                                  fontWeight: "normal",
                                }}
                                className="text-center p-0"
                              >
                                {item.pais_origen_nombre}
                              </td>
                            ) : null}

                            <td
                              style={{
                                border: "1px solid #000",
                                fontWeight: "normal",
                              }}
                              className="text-center p-0"
                            >
                              {item.cantidad}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <p>
                    <b>Solicitado por: </b>
                    {this.props.caso_especial.nombre_solicitante}
                  </p>

                  {this.props.caso_especial.fabricante_razon_social !==
                  "N/A" ? (
                    <p>
                      <b>Fabricante: </b>
                      {this.props.caso_especial.fabricante_razon_social}
                    </p>
                  ) : null}

                  {this.props.caso_especial.pais_origen_nombre !== "N/A" ? (
                    <p>
                      <b>Origen: </b>
                      {this.props.caso_especial.pais_origen_nombre}
                    </p>
                  ) : null}

                  <p>
                    <b>Procedencia: </b>
                    {this.props.caso_especial.pais_procedencia_nombre}
                  </p>

                  <p>
                    <b>Consignada(s) en Factura No: </b>
                    {this.props.caso_especial.no_factura}
                  </p>

                  <p>
                    <b>Guía Aérea No: </b>
                    {this.props.caso_especial.guia_area}
                  </p>

                  <p>
                    <b>Autorizado por: </b>
                    {this.props.caso_especial.autorizado_por}
                  </p>

                  <p>
                    <b>
                      Managua, {this.props.caso_especial.fecha_aprueba}. Hora:{" "}
                      {this.props.caso_especial.hora}
                    </b>
                    {/* {this.props.licencia.codigo_regencia} */}
                  </p>
                </div>

                <br></br>
                <br></br>
                <br></br>

                <p
                  style={{
                    textAlign: "center",
                    margin: "8%",
                    marginTop: "15em",
                  }}
                >
                  <center>
                    <div
                      style={{ borderBottom: "1px solid #333", width: "50%" }}
                    >
                      {!["1", "7", "8"].includes(
                        this.props.caso_especial.tipo_importacion_id
                      )
                        ? this.props.caso_especial.estimado
                        : this.props.caso_especial.autorizado_por}
                    </div>
                  </center>
                  <br></br>
                  SELLO Y FIRMA
                </p>
              </form>
            </div>
            <hr />
          </div>
        </ModalBody>
        <ModalFooter>
          <ReactToPrint
            content={() => componentRef.current}
            pageStyle=""
            trigger={() => (
              <button id="btn-imprimir" className="btn btn-primary m-r-5">
                Imprimir
              </button>
            )}
            // onBeforeGetContent={() =>
            //   this.props.imprimir(
            //     this.props.licencia.licencia_id,
            //     this.props.licencia.tramite_id,
            //     this.props.licencia.impresiones
            //   )
            // }
          />
          <button className="btn btn-white" onClick={this.props.change}>
            Cerrar
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
export default Aval;
